import React from "react"; 

// קומפוננטת תנאי שימוש מלאה (RTL), תבנית כללית לאתר מסחר/תוכן בישראל
export default function Terms() { // מייצא את הקומפוננטה כברירת מחדל
  const lastUpdated = new Date().toLocaleDateString("he-IL"); // יוצר תאריך עדכון בפורמט עברי

  return ( // מחזיר JSX
    <main dir="rtl" lang="he" className="nfig-legal my-10 space-y-6"> {/* מכולה מרכזית ב‑RTL */}
      <header className="space-y-1"> {/* כותרת עמוד */}
        <h1 className="text-3xl font-bold">תנאי שימוש</h1> {/* כותרת ראשית */}
        <p className="text-sm text-gray-500">תאריך עדכון אחרון: {lastUpdated}</p> {/* תאריך עדכון */}
      </header>

      <section className="space-y-2"> {/* סעיף: קבלה */}
        <h2 className="text-xl font-semibold">1. קבלת התנאים</h2>
        <p>
          השימוש באתר <strong>[שם האתר/העסק]</strong> (“האתר”, “אנחנו”) כפוף לתנאים אלה. הגישה או השימוש באתר מהווים אישור כי קראת והסכמת לתנאים.
        </p>
      </section>

      <section className="space-y-2"> {/* סעיף: שינויים */}
        <h2 className="text-xl font-semibold">2. שינויים בתנאים ובשירות</h2>
        <p>
          אנו רשאים לעדכן את התנאים ו/או לשנות את השירות מעת לעת. הגרסה העדכנית תפורסם באתר ותיכנס לתוקף עם פרסומה.
        </p>
      </section>

      <section className="space-y-2"> {/* סעיף: כשירות */}
        <h2 className="text-xl font-semibold">3. כשירות לשימוש</h2>
        <p>
          השימוש באתר מיועד לבני 16 ומעלה. אם אינך עומד/ת בדרישה זו, אין להשתמש באתר ללא הסכמת הורה/אפוטרופוס.
        </p>
      </section>

      <section className="space-y-2"> {/* סעיף: חשבון */}
        <h2 className="text-xl font-semibold">4. חשבון משתמש ואבטחה</h2>
        <p>
          במידה ונדרש רישום, עליך לספק מידע מדויק ולעדכנו בעת הצורך. האחריות לשמירת סודיות פרטי ההתחברות ולכל פעילות בחשבון — עליך.
        </p>
      </section>

      <section className="space-y-2"> {/* סעיף: הזמנות ותמחור */}
        <h2 className="text-xl font-semibold">5. הזמנות, תמחור וזמינות</h2>
        <p>
          מחירים וזמינות מוצרים/שירותים עשויים להשתנות ללא הודעה. אנו עשויים לבטל או לסרב להזמנה לפי שיקול דעתנו (לרבות עקב חוסר מלאי/טעות תמחור).
        </p>
      </section>

      <section className="space-y-2"> {/* סעיף: משלוח והחזרות */}
        <h2 className="text-xl font-semibold">6. משלוח, החזרות וביטולים</h2>
        <p>
          מדיניות המשלוח, ההחזרות והביטולים מפורטת בדף ייעודי באתר.
        </p>
      </section>

      <section className="space-y-2"> {/* סעיף: קניין רוחני */}
        <h2 className="text-xl font-semibold">7. קניין רוחני</h2>
        <p>
          כל הזכויות בתכני האתר (לרבות טקסטים, גרפיקות, לוגואים, תמונות וקוד) שמורות לנו ו/או לבעלי הזכויות. אין להעתיק, להפיץ, לשכפל או לבצע יצירות נגזרות ללא היתר בכתב.
        </p>
      </section>

      <section className="space-y-2"> {/* סעיף: תוכן משתמשים */}
        <h2 className="text-xl font-semibold">8. תוכן משתמשים</h2>
        <p>
          אם הנך מעלה תוכן לאתר, אתה מצהיר כי יש לך הזכויות הנדרשות וכי התוכן אינו מפר זכויות צדדים שלישיים או דין. אתה מעניק לנו רישיון לא בלעדי להצגת התוכן במסגרת האתר.
        </p>
      </section>

      <section className="space-y-2"> {/* סעיף: שימוש אסור */}
        <h2 className="text-xl font-semibold">9. שימוש אסור באתר</h2>
        <ul className="list-disc pr-5 space-y-1">
          <li>פעילות בלתי חוקית, פוגענית או מטעה.</li>
          <li>פגיעה בזכויות קניין רוחני או פרטיות.</li>
          <li>שיבוש פעילות האתר, לרבות ניסיונות חדירה/הנדסה לאחור.</li>
          <li>איסוף מידע משתמשים ללא הסכמה.</li>
        </ul>
      </section>

      <section className="space-y-2"> {/* סעיף: קישורים */}
        <h2 className="text-xl font-semibold">10. קישורים ואתרים של צד שלישי</h2>
        <p>
          האתר עשוי לכלול קישורים לאתרים חיצוניים. איננו אחראים לתוכנם או לנזק שייגרם משימוש בהם. מומלץ לעיין בתנאי השימוש והפרטיות של אותם אתרים.
        </p>
      </section>

      <section className="space-y-2"> {/* סעיף: אחריות */}
        <h2 className="text-xl font-semibold">11. הצהרת אחריות</h2>
        <p>
          האתר מוצע “כמות שהוא” (AS‑IS) ללא מצגים או אחריות מכל סוג, במידה המותרת לפי דין. ייתכנו טעויות, השמטות או חוסר זמינות מעת לעת.
        </p>
      </section>

      <section className="space-y-2"> {/* סעיף: הגבלת אחריות */}
        <h2 className="text-xl font-semibold">12. הגבלת אחריות</h2>
        <p>
          במידה המרבית המותרת לפי דין, לא נהיה אחראים לכל נזק עקיף/תוצאתי/מיוחד הנובע מהשימוש באתר או באי‑יכולת להשתמש בו.
        </p>
      </section>

      <section className="space-y-2"> {/* סעיף: שיפוי */}
        <h2 className="text-xl font-semibold">13. שיפוי</h2>
        <p>
          אתה מתחייב לשפות אותנו בגין כל תביעה/הפסד/הוצאה (לרבות הוצאות משפט) הנובעים מהפרת תנאים אלה או משימושך הבלתי חוקי באתר.
        </p>
      </section>

      <section className="space-y-2"> {/* סעיף: סיום */}
        <h2 className="text-xl font-semibold">14. סיום וגישה</h2>
        <p>
          אנו רשאים להשעות או לסיים את הגישה לאתר לפי שיקול דעתנו, לרבות עקב הפרת תנאי השימוש.
        </p>
      </section>

      <section className="space-y-2"> {/* סעיף: דין ושיפוט */}
        <h2 className="text-xl font-semibold">15. דין ושיפוט</h2>
        <p>
          על תנאים אלה יחולו דיני מדינת ישראל וסמכות השיפוט הבלעדית נתונה לבתי המשפט המוסמכים באזור <strong>[למשל תל‑אביב/חיפה/ירושלים]</strong>.
        </p>
      </section>

      <section className="space-y-2"> {/* סעיף: יצירת קשר */}
        <h2 className="text-xl font-semibold">16. יצירת קשר</h2>
        <address className="not-italic">
          לשאלות בנוגע לתנאים: <a className="text-blue-700 underline" href="mailto:example@yourshop.com">example@yourshop.com</a> | כתובת: <strong>[כתובת מלאה]</strong> | טל׳: <strong>[מספר]</strong>
        </address>
      </section>
    </main>
  ); // סוף JSX
} // סוף הקומפוננטה
